import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiXMark } from 'react-icons/hi2';
import { FaInstagram, FaFacebookF, FaLinkedinIn } from 'react-icons/fa6';
import { FiMail } from 'react-icons/fi';
import fullPageMenuImg from '../../assets/images/menuImg.png';

const FullPageMenu = ({ isOpen, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setIsClosing(false);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setIsClosing(false);
    }
  }, [isOpen]);

  const getAnimClass = () => {
    if (isOpen) {
      return 'translate-y-0 opacity-100 pointer-events-auto scale-100';
    }
    if (isClosing) {
      return '-translate-y-full md:translate-y-0 opacity-0 pointer-events-none scale-100 md:scale-[0.99]';
    }
    return 'translate-y-0 opacity-0 pointer-events-none scale-[0.99]';
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-between px-[13px] transition-all duration-500 bg-cover bg-center bg-no-repeat ${getAnimClass()}`}
      style={{
        backgroundImage: `linear-gradient(
      rgba(18, 16, 14, 0.22),
      rgba(18, 16, 14, 0.22)
    ), url(${fullPageMenuImg})`,
      }}
    >
      <button
        onClick={onClose}
        aria-label="Close Menu"
        className="absolute top-6 right-6 md:top-10 md:right-10 text-white hover:opacity-70 transition-opacity focus:outline-none cursor-pointer z-10"
      >
        <HiXMark className="w-8 h-8" />
      </button>

      <div className="font-EthicNewLight w-full max-w-4xl mx-auto my-auto flex flex-col items-center text-center py-10">

        <div className="text-white flex flex-col items-center space-y-4 md:space-y-6 select-none">

          <div className="flex items-center justify-center flex-nowrap font-EthicNewLight font-normal text-[35px] md:text-[54px] leading-[1.1] tracking-[0em] gap-3">
            <Link to="/" onClick={onClose} className="hover:opacity-75 transition-opacity">HOME</Link>
            <span className="font-light text-white">/</span>
            <Link to="/about" onClick={onClose} className="hover:opacity-75 transition-opacity">ABOUT</Link>
          </div>

          <div className="hidden md:flex items-center justify-center flex-nowrap font-EthicNewLight font-normal text-[35px] md:text-[54px] leading-[1.1] tracking-[0em] gap-3">
            <Link to="/services" onClick={onClose} className="hover:opacity-75 transition-opacity">SERVICES</Link>
            <span className="font-light text-white">/</span>
            <Link to="/websites" onClick={onClose} className="hover:opacity-75 transition-opacity">WEBSITES</Link>
          </div>

          <div className="flex md:hidden items-center justify-center flex-nowrap font-EthicNewLight font-normal text-[35px] md:text-[54px] leading-[1.1] tracking-[0em] gap-3">
            <Link to="/services" onClick={onClose} className="hover:opacity-75 transition-opacity">SERVICES</Link>
            <span className="font-light text-white">/</span>
          </div>

          <div className="flex md:hidden items-center justify-center flex-nowrap font-EthicNewLight font-normal text-[35px] md:text-[54px] leading-[1.1] tracking-[0em] gap-3">
            <Link to="/websites" onClick={onClose} className="hover:opacity-75 transition-opacity">WEBSITES</Link>
            <span className="font-light text-white">/</span>
          </div>

          <div className="flex items-center justify-center flex-nowrap font-EthicNewLight font-normal text-[35px] md:text-[54px] leading-[1.1] tracking-[0em] gap-3">
            <Link to="/process" onClick={onClose} className="hover:opacity-75 transition-opacity">PROCESS</Link>
            {/* <span className="font-light text-white">/</span>
            <Link to="/blog" onClick={onClose} className="hover:opacity-75 transition-opacity">BLOG</Link> */}
          </div>

          <div className="flex items-center justify-center flex-nowrap font-EthicNewLight font-normal text-[35px] md:text-[54px] leading-[1.1] tracking-[0em] gap-3">
            <Link to="/inquiry" onClick={onClose} className="hover:opacity-75 transition-opacity">INQUIRY</Link>
          </div>

        </div>

        <div className="hidden md:block font-inter-display-medium font-light mt-8 text-[14px] md:text-[17px] text-white tracking-[0em] leading-[1.6] max-w-md text-center">
          <p>Clean, simple websites designed around your brand by Princy Patel.</p>
        </div>

        <div className="mt-8 flex items-center justify-center gap-[10px] text-white">
          <a href="https://www.instagram.com/seasalt_creative/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a> */}
          <a
            href="mailto:hello@seasaltcreative.com"
            aria-label="Email"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://mail.google.com/mail/?view=cm&fs=1&to=hello@seasaltcreative.com", "_blank");
            }}
          >
            <FiMail />
          </a>
        </div>

      </div>
    </div>
  );
};

export default FullPageMenu;
